import React from 'react';
import { Icon } from '@rsuite/icons';

import GearIcon from '@rsuite/icons/Gear';
import DashboardIcon from '@rsuite/icons/Dashboard';
import TextImageIcon from '@rsuite/icons/TextImage';
import BarLineChartIcon from '@rsuite/icons/BarLineChart';
import TrendIcon from '@rsuite/icons/Trend';
import AdminIcon from '@rsuite/icons/Admin';
import PeoplesUploadedIcon from '@rsuite/icons/PeoplesUploaded';
import TagIcon from '@rsuite/icons/Tag';
import DetailIcon from '@rsuite/icons/Detail';


export const appNavs = [
  {
    eventKey: 'dashboard',
    icon: <Icon as={DashboardIcon} />,
    title: 'Dashboard',
    to: '/dashboard'
  },
  {
    eventKey: 'product',
    icon: <Icon as={TextImageIcon} />,
    title: 'Manage Product',
    to: '/products'
  },
  {
    eventKey: 'catalogue',
    icon: <Icon as={BarLineChartIcon} />,
    title: 'Create Catalogue',
    to: '/selection'
  },
  {
    eventKey: 'ccatalogue',
    icon: <Icon as={DetailIcon} />,
    title: 'Manage Catalogue',
    to: '/manageCatalogue'
  },
  {
    eventKey: 'gallery',
    icon: <Icon as={TrendIcon} />,
    title: 'Manage Collection',
    to: '/manageCollection'
  },
  {
    eventKey: 'gallery',
    icon: <Icon as={AdminIcon} />,
    title: 'Buyer',
    to: '/addbuyer'
  },
  
  {
    eventKey: 'marketing',
    icon: <Icon as={GearIcon} />,
    title: 'Settings',
    to: '/calendar',
    children: [
           {
             eventKey: 'members',
             title: 'Attribute Master',
             to: '/table-members'
           },
           {
             eventKey: 'virtualized',
             title: 'Attribute Show',
            to: '/table-virtualized'
           },
           {
            eventKey: 'virtualized',
            title: 'User Manage',
           to: '/table-virtualized'
          }

          ]
  },
  // {
  //   eventKey: 'tables',
  //   icon: <Icon as={VscTable} />,
  //   title: 'Tables',
  //   to: '/table-members',
  //   children: [
  //     {
  //       eventKey: 'members',
  //       title: 'Members',
  //       to: '/table-members'
  //     },
  //     {
  //       eventKey: 'virtualized',
  //       title: 'Virtualized Table',
  //       to: '/table-virtualized'
  //     }
  //   ]
  // },
  // {
  //   eventKey: 'forms',
  //   icon: <Icon as={MdModeEditOutline} />,
  //   title: 'Forms',
  //   to: '/form-basic',
  //   children: [
  //     {
  //       eventKey: 'form-basic',
  //       title: 'Basic',
  //       to: '/form-basic'
  //     },
  //     {
  //       eventKey: 'form-wizard',
  //       title: 'Wizard',
  //       to: '/form-wizard'
  //     }
  //   ]
  // },
  // {
  //   eventKey: 'authentication',
  //   title: 'Authentication',
  //   icon: <Icon as={MdFingerprint} />,
  //   children: [
  //     {
  //       eventKey: 'sign-in',
  //       title: 'Sign In',
  //       to: '/sign-in'
  //     },

  //     {
  //       eventKey: 'sign-up',
  //       title: 'Sign Up',
  //       to: '/sign-up'
  //     },

  //     {
  //       eventKey: 'error400',
  //       title: 'Error 404',
  //       to: '/error-404'
  //     },
  //     {
  //       eventKey: 'error500',
  //       title: 'Error 500',
  //       to: '/error-500'
  //     }
  //   ]
  // },

  // {
  //   eventKey: 'components',
  //   title: 'Components',
  //   icon: <CubesIcon />,
  //   href: 'https://rsuitejs.com/components/overview/',
  //   target: '_blank'
  // }
];
